import type { AdSetEntry, CampaignEntry } from '../../api';

export const campaignBudgetDisplay = (
  campaign: CampaignEntry,
  budgets: Record<string, string> | undefined,
): string => (campaign.is_cbo ? budgets?.[campaign.id] ?? '-' : '-');

export const adSetBudgetDisplay = (
  adSet: AdSetEntry,
  budgets: Record<string, string> | undefined,
): string => (adSet.is_cbo ? '-' : budgets?.[adSet.id] ?? '-');

export const groupAdSetsByCampaignId = (
  adSets: AdSetEntry[] | undefined,
): Record<string, AdSetEntry[]> =>
  (adSets ?? []).reduce<Record<string, AdSetEntry[]>>((acc, adSet) => {
    (acc[adSet.campaign_id] ??= []).push(adSet);
    return acc;
  }, {});

export const resolveAdTypeName = (
  namesByCode: Map<string, string>,
  code: string | undefined,
): string | undefined => (code ? namesByCode.get(code) ?? code : undefined);

export const creativesCountLabel = (count: number): string => `${count} creatives`;
